import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/ServicesPage.css';

const ServicesPage = () => {
  // URL hash değerini almak için useLocation kullanıyoruz
  const location = useLocation();
  
  // Servislere referans oluşturma
  const serviceRefs = {
    'istisna-akdi': useRef(null),
    'mavi-kart': useRef(null),
    'yeni-goc-yasasi': useRef(null)
  };
  
  // Sayfa yüklendiğinde ve URL değiştiğinde scroll işlemi
  useEffect(() => {
    // URL'de bir hash değeri varsa (örn: #mavi-kart)
    if (location.hash) {
      // # işaretini kaldır
      const id = location.hash.substring(1);
      
      // Referansı olan öğeye scroll yap
      if (serviceRefs[id] && serviceRefs[id].current) {
        // Render tamamlandıktan sonra smooth scroll için setTimeout kullan
        setTimeout(() => {
          const yOffset = -100; // Üst navigasyon çubuğu için offset
          const element = serviceRefs[id].current;
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          
          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        }, 100);
      }
    } else {
      // Hash yoksa, sayfanın en üstüne git
      window.scrollTo(0, 0);
    }
  }, [location]);
  
  // Hızlı erişim bağlantıları için özel scroll fonksiyonu
  const scrollToService = (id) => (e) => {
    e.preventDefault();
    
    if (serviceRefs[id] && serviceRefs[id].current) {
      const yOffset = -100; 
      const element = serviceRefs[id].current;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
      
      // URL'i güncelle ama sayfa yenileme yapma
      window.history.pushState(null, '', `#${id}`);
    }
  };

  // Belgedeki bilgilere uygun olarak düzenlendi
  const services = [
    {
      id: 'istisna-akdi',
      title: 'İstisna Akdi',
      image: '/images/services/istisna-akdi.jpg',
      fullDescription: [
        'Almanya Federal Cumhuriyetinin ve Ülkemizin ekonomik işbirliğini güvence altına almak, Türk Firmalarına Alman pazarına giriş fırsatı sağlamak, işgücü piyasasının ihtiyaçları da göz önünde bulundurmak suretiyle, Türk işgücüne istihdam olanağı sağlamak amacıyla Ülkemiz ile Almanya Federal Cumhuriyeti arasında "Türk Firmaları İşçilerinin İstisna Akdi Çerçevesinde İstihdamına İlişkin Anlaşma" 18 Kasım 1991 günü imzalanmıştır.',
        'Almanya`dan anlaşma çerçevesinde aldığı işlerde Türk işçisi çalıştırmak isteyen Türk firmalarının işlemleri "24.04.2004 tarihli Resmi Gazete\'de yayımlanan Tebliğ" doğrultusunda yürütülmektedir.',
        'İş anlaşması sonucunda Türkiye\'de yerleşik olan Türk firmaları Federal Almanya\'da yerleşik firmalardan aldıkları işlerde kendi işçilerini bahsedilen ülkeye götürebileceklerdir. Götürülebilen işçi sayısında belli bir kota vardır.'
      ],
      details: [
        'Almanya Federal Cumhuriyeti tarafından Ülkemize verilen kota bir yıllık süreyi kapsamakta ve yıldan yıla değişebilmektedir. Örneğin 01.10.2011 – 30.09.2012 tarihleri arasında 6170 kişi olarak belirlenmiştir.',
        'Ülkemiz Türkiye`nin kanunlarına göre kurulu ve halen faaliyet gösteren alanında kendini kanıtlamış Türk firmaları Almanya`dan iş alan, Alman kanunlarına göre kurulmuş olan firmaların almış oldukları işler için taşeron olarak başvurabilir ve taşeronluğunu almış olduğu işle ilgili ve Kurumca istenilen diğer belgeleri de ibraz etmek şartıyla kota tahsisi için gerekli mercilere başvurabilir.',
        'İstisna Akdinden yararlanmak isteyen şirketler arasında belli şartlara uygun olarak bir iş anlaşması imzalanmak zorundadır. İşverenler işçi teminatı olarak belli bir miktarı ilgili kuruma yatırmak zorundadır.',
        'İstisna Akdi geçici nitelikteki işleri kapsamaktadır. Sözleşme gereği işin bitmesi halinde işçilerin Ülkemize dönmeleri gerekmektedir.',
        'İşçilerin 30 günden az süreli işlere götürülmemeleri gerekmekle birlikte iş 200.000 Euronun üzerinde ise bu süre gözönüne alınmamaktadır.'
      ],
      workPermit: [
        'Anlaşmanın 6. maddesinde; "Çalışma izninin azami süresi 2 yıldır. İstisna akdi faaliyetinin önceden tahmin edilmeyen bir olay nedeniyle 2 yıldan fazla sürmesi halinde, çalışma izni 6 aya kadar uzatılır.',
        'İstisna akdi faaliyetinin 2 yıldan fazla süreceği peşinen belli ise, çalışma izni azami üç yıla kadar verilir.',
        'Münferiden yönetici veya idari personel olarak çalışan işçilere azami 4 yıl için çalışma izni verilir" hükmü bulunmaktadır.',
        'Bundan dolayı işverenlerde işçileri ile bu sürelerle orantılı sözleşme imzalamalıdır.'
      ]
    },
    {
      id: 'mavi-kart',
      title: 'Mavi Kart (Blue Card)',
      image: '/images/services/blue-card.jpg',
      fullDescription: [
        'Avrupa Mavi kartı AB/AEA milletlerinden olmayan nitelikli insanlar için bir çalışma ve oturma iznidir. Mavi kart, kapsamlı sosyo-ekonomik haklar sunar ve Avrupa\'da daimi ikamet için bir yol sağlar.',
        'Yurtdışındaki vatandaşlarımızın Türkiye\'deki iş ve işlemlerini rahat bir şekilde gerçekleştirmesini sağlamak amacıyla hayata geçirilen Mavi Kart, süreç içerisinde gerçekleştirilen yasal düzenlemelerle daha işlevsel hale getirilmiştir.',
        'Doğumla Türk vatandaşı olup da vatandaşlıktan çıkma izni almak suretiyle Türk vatandaşlığını kaybedenlere ve vatandaşlıktan çıktıktan sonra doğan çocuklarına da verilen Mavi Kart, kanundaki değişiklikle birlikte "değerli kâğıt" kapsamına alınmıştır.',
        'Ancak Blue Card başvurusunda bulunacak kişilerin Almanya\'nın belirlediği nitelikli işgücü tanımına uygun olduklarını ispatlamaları gerekiyor.'
      ],
      eligibility: [
        'Avrupa Birliği dışında yaşayan, alanında uzmanlaşmış ve en az 3 ila 5 yıl profesyonel iş tecrübesine sahip kişiler Blue Card (mavi kart) başvurusunda bulunabiliyor.',
        'Aslında bu başvuruda iş tecrübe süresi için kesin olarak belirlenmiş bir madde yok. Ancak bir alanda kalifiye olduğunuzu kanıtlamak için belli bir süre çalışmış olmak ve referans mektupları başvurunuzun kabul edilme şansını daha yukarı çekecektir.'
      ],
      countries: [
        'Blue Card (Mavi Kart) alarak çalışmak üzere Almanya\'ya gelenler arasında Türk vatandaşları dördüncü sırada yer almaktadır. Almanya\'da Mavi Kart ile çalışan Türklerin sayısının ise 2 bin 476 olduğu bilinmektedir.',
        'Blue Card (Mavi kart) veren ülkelerin en başında gelen Almanya\'dan sonra en çok mavi kart veren ülkeler sırasıyla Polonya, Fransa, İtalya, Avusturya, Belçika, Bulgaristan, Hırvatistan, Kıbrıs, Çek Cumhuriyeti, Estonya, Finlandiya, Yunanistan, Macaristan, Letonya, Litvanya, Lüksemburg, Malta, Hollanda, Portekiz, Romanya, Slovakya, Slovenya, İspanya ve İsveç\'tir.'
      ],
      eligibleOccupations: [
        'Yüksek nitelikli işçi',
        'Araştırma görevlisi',
        'Öğrenci',
        'Meslek kursiyerliği',
        'Mevsimlik çalışan işçi',
        'Teknik alanlarda çalışan kişiler (mühendis-mimar vs.)',
        'Bilişim sektöründe çalışan kişiler (yazılımcı, web tasarımcı vs.)',
        'Sağlık sektöründe çalışan kişiler',
        'Üst düzey yöneticiler'
      ],
      requirements: [
        'Lisans mezunu olmak ve diplomanızın denkliğinin olması',
        'Alanında profesyonel olmak',
        'En az 3-5 yıllık iş deneyiminin olması',
        'Kalifiye olmak',
        'Almanya\'da bir firmadan iş teklifi almanız ya da bir iş sözleşmesi imzalamış olmanız',
        'Almanya\'da ki işinizden yıllık en az 50.000 Euro brüt maaş almanız gerekmektedir'
      ],
      serviceNote: 'Eğer bu şartlara uygunsanız şirketimiz sizin için gerekli bürokratik işlemleri halletmektedir.'
    },
    {
      id: 'yeni-goc-yasasi',
      title: 'Yeni Göç Yasası',
      image: '/images/services/yeni-goc-yasasi.webp',
      fullDescription: [
        '1 Mart 2021 tarihinde resmi olarak Almanya Federal Hükûmeti tarafından kabul edilen ve yürürlüğe giren kanundur. Avrupa Birliği dışından nitelikli uzmanları Almanya\'ya getirmeyi planlanmaktadır.',
        'Yeni göç yasası hukuki birçok değişikliği de beraberinde getirmiştir. İş arama vizesi şartlarındaki değişikliklerin yanında kişilerin Almanya\'da iş bulması da kolaylaşmıştır.'
      ],
      keyChanges: [
        '1 Mart 2021 öncesinde Alman şirketlerin öncelikli olarak kendi vatandaşlarını işe alma zorunluluğu vardı.',
        'Eğer iş pozisyonuna uygun çalışanı kendi vatandaşları arasından bulamazsa, seçenek olarak Avrupa Birliği vatandaşlarını işe alabiliyordu.',
        'Almanya Yeni Göç Yasası ile birlikte eski şartlar değişmiştir.'
      ],
      qualifications: [
        'Meslek eğitimi almış nitelikli iş gücü, kanunen kabul edilmiş bir meslek eğitimini bitirmiş kişilerdir.',
        'Eğer nitelikli meslek eğitimi Almanya harici bir ülkede alınmışsa, vize başvurusundan önce Almanya\'daki yetkili denklik makamlarınca söz konusu meslek eğitiminin Almanya\'daki meslek eğitimi ile eşdeğer olup olmadığı değerlendirilir.',
        'Akademik eğitim almış nitelikli iş gücü, Almanya\'da bir yüksekokuldan mezun veya denklik işlemleri tamamlanmış başka bir ülkedeki yüksekokuldan mezun ya da Almanya\'daki yüksekokul diplomasına benzer başka bir ülke yüksekokul diplomasına sahip kişilerdir.',
        'Herhangi bir niteliğe sahip olmayan veya düşük nitelikli eğitim almış kişiler yasaya göre nitelikli iş gücü kabul edilmez.'
      ],
      keyRequirements: [
        'Almanca dil becerisini belgelemek',
        'Almanya dışı bir ülkede alınmış olunan diplomanın denkliğini almak'
      ]
    }
  ];

  return (
    <div className="services-page">
      {/* Hero Banner */}
      <div className="services-hero">
        <div className="container">
          <h1>Hizmetlerimiz</h1>
          <p>PHG Danışmanlık olarak, yurtdışında yeni bir hayat kurmanız için ihtiyaç duyacağınız tüm danışmanlık hizmetlerini sunuyoruz.</p>
        </div>
      </div>

      {/* Hizmetler İçerik */}
      <div className="services-content">
        <div className="container">
          {/* Hizmet Navigasyonu */}
          <div className="services-nav">
            <div className="nav-title">Hızlı Erişim</div>
            <ul>
              {services.map(service => (
                <li key={service.id}>
                  <a href={`#${service.id}`} onClick={scrollToService(service.id)}>{service.title}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Hizmet Detayları */}
          <div className="services-details">
            {/* İstisna Akdi - ref ekleniyor */}
            <div className="service-detail" id="istisna-akdi" ref={serviceRefs['istisna-akdi']}>
              <div className="service-header">
                <div className="service-image">
                  <img src={services[0].image} alt={services[0].title} />
                </div>
                <h2>{services[0].title}</h2>
              </div>
              <div className="service-body">
                {services[0].fullDescription.map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}

                <h3>İstisna Akdi Detayları</h3>
                <ul className="details-list">
                  {services[0].details.map((detail, idx) => (
                    <li key={idx}>{detail}</li>
                  ))}
                </ul>

                <h3>Çalışma İzni Süreleri</h3>
                <ul className="work-permit-list">
                  {services[0].workPermit.map((permit, idx) => (
                    <li key={idx}>{permit}</li>
                  ))}
                </ul>

                {/* Danışmanlık talebi için CTA */}
                <div className="service-cta">
                  <h3>İstisna Akdi hakkında detaylı bilgi almak ister misiniz?</h3>
                  <Link to="/iletisim" className="cta-button">Danışmanlık Talebi Oluştur</Link>
                </div>
              </div>
            </div>

            {/* Mavi Kart - ref ekleniyor */}
            <div className="service-detail" id="mavi-kart" ref={serviceRefs['mavi-kart']}>
              <div className="service-header">
                <div className="service-image">
                  <img src={services[1].image} alt={services[1].title} />
                </div>
                <h2>{services[1].title}</h2>
              </div>
              <div className="service-body">
                {services[1].fullDescription.map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}

                <h3>Blue Card (Mavi kart) için kimler başvuruda bulunabilir?</h3>
                {services[1].eligibility.map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}

                <h3>AB ülkeleri içinde Blue Card (Mavi kart) vermeyi kabul eden ülkeler</h3>
                {services[1].countries.map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}

                <h3>Almanya Blue Card (Mavi Kart) için Uygun Meslekler</h3>
                <ul className="eligible-occupations-list">
                  {services[1].eligibleOccupations.map((occ, idx) => (
                    <li key={idx}>{occ}</li>
                  ))}
                </ul>

                <h3>Mavi Kart Başvuru Şartları</h3>
                <ul className="requirements-list">
                  {services[1].requirements.map((req, idx) => (
                    <li key={idx}>{req}</li>
                  ))}
                </ul>

                <p className="highlighted-note">{services[1].serviceNote}</p>

                {/* Danışmanlık talebi için CTA */}
                <div className="service-cta">
                  <h3>Mavi Kart başvurusu konusunda yardıma mı ihtiyacınız var?</h3>
                  <Link to="/iletisim" className="cta-button">Danışmanlık Talebi Oluştur</Link>
                </div>
              </div>
            </div>

            {/* Yeni Göç Yasası - ref ekleniyor */}
            <div className="service-detail" id="yeni-goc-yasasi" ref={serviceRefs['yeni-goc-yasasi']}>
              <div className="service-header">
                <div className="service-image">
                  <img src={services[2].image} alt={services[2].title} />
                </div>
                <h2>{services[2].title}</h2>
              </div>
              <div className="service-body">
                {services[2].fullDescription.map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}

                <h3>Yeni Göç Yasası İle Gelen Değişiklikler</h3>
                <ul className="key-changes-list">
                  {services[2].keyChanges.map((change, idx) => (
                    <li key={idx}>{change}</li>
                  ))}
                </ul>

                <h3>Nitelikli İşgücü Tanımları</h3>
                <ul className="qualifications-list">
                  {services[2].qualifications.map((qualification, idx) => (
                    <li key={idx}>{qualification}</li>
                  ))}
                </ul>

                <h3>Temel Gereksinimler</h3>
                <ul className="key-requirements-list">
                  {services[2].keyRequirements.map((req, idx) => (
                    <li key={idx}>{req}</li>
                  ))}
                </ul>

                {/* Danışmanlık talebi için CTA */}
                <div className="service-cta">
                  <h3>Yeni Göç Yasası konusunda profesyonel destek almak ister misiniz?</h3>
                  <Link to="/iletisim" className="cta-button">Danışmanlık Talebi Oluştur</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Hizmet İletişim CTA */}
      <div className="services-contact-cta">
        <div className="container">
          <h2>Profesyonel Danışmanlık Hizmetlerimizden Yararlanın</h2>
          <p>
            PHG Danışmanlık olarak, yurtdışı çalışma ve oturum izni süreçlerinizde yanınızdayız.
            Uzman ekibimizle tüm bürokratik işlemleri sizin için yönetiyoruz.
          </p>
          <Link to="/iletisim" className="contact-button">Bize Ulaşın</Link>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;